<template>
  <section class="page-section">
    <el-button
      type="primary"
      class="btn-add-block"
      @click="pageNavigateToPermissionRoleAdd"
      >新增角色</el-button
    >

    <!-- table -->
    <div class="table-region" v-loading="tableLoading">
      <el-table size="small" :data="tableData">
        <el-table-column label="角色名">
          <template slot-scope="scope">
            <p>{{ scope.row.name }}</p>
          </template>
        </el-table-column>
        <el-table-column label="描述">
          <template slot-scope="scope">
            <p>{{ scope.row.description }}</p>
          </template>
        </el-table-column>
        <el-table-column label="员工数">
          <template slot-scope="scope">
            <router-link
              class="router-link-active"
              :to="{
                path: '/permission/staff/list',
                query: { roleId: scope.row.id },
              }"
              >{{ scope.row.staffNum }}</router-link
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" align="right">
          <template slot-scope="scope">
            <el-button
              size="small"
              type="text"
              @click="pageNavigateToPermissionRoleEdit(scope.row)"
              >编辑</el-button
            >
            <el-popover
              placement="left"
              width="160"
              v-model="scope.row.deleteVisible"
              popper-class="confirm-popover"
            >
              <p>确定删除？</p>
              <div>
                <el-button
                  size="small"
                  type="default"
                  plain
                  @click="scope.row.deleteVisible = false"
                  >取消</el-button
                >
                <el-button
                  size="small"
                  type="primary"
                  @click="handleDelete(scope)"
                  >确定</el-button
                >
              </div>

              <span class="text lh48 ml20" slot="reference"
                ><el-button size="small" type="text" :loading="deleteLoading"
                  >删除</el-button
                ></span
              >
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="table-footer" v-if="page.total > 0">
      <div class="selection-operate"></div>

      <div class="pagination-wrap">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[20, 50, 100]"
          :pager-count="5"
          :current-page="page.current"
          :page-size="page.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
        >
        </el-pagination>
      </div>
    </div>
  </section>
</template>

<script>
import { permissionRoleList, permissionRoleDelete } from "@/common/api";

export default {
  name: "permissionRoleList",
  data() {
    return {
      tableLoading: true,
      tableData: [], //表格数据
      page: {
        current: 1,
        size: 20,
        total: 0,
      },

      deleteLoading: false,
    };
  },
  methods: {
    /**
     * [getList description] 获取表格数据
     * @return {[type]} [description]
     */
    getList: function () {
      this.tableLoading = true;

      let params = {
        pageNo: this.page.current,
        pageSize: this.page.size,
      };

      permissionRoleList(params)
        .then((res) => {
          this.tableLoading = false;

          let { code, data, msg } = res;

          if (code == 0) {
            let dataArray = data.records || [];

            this.tableData = dataArray;
            this.page.total = data.total;
            this.$nextTick(() => {
              const scrollContainer = document.querySelector(".app-container");
              if (scrollContainer) {
                scrollContainer.scrollTop = 0;
              }
            });
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.tableLoading = false;
          this.$message.error("服务器异常");
        });
    },
    /**
     * [handleSizeChange description] 分页每页条数变化
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleSizeChange(val) {
      this.page.current = 1;
      this.page.size = val;
      this.getList();
    },
    /**
     * [handleCurrentChange description] 选择分页第几页
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleCurrentChange(val) {
      this.page.current = val;
      this.getList();
    },
    /**
     * [pageNavigateToPermissionRoleAdd description] 跳转新增等级权益
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    pageNavigateToPermissionRoleAdd() {
      this.$router.push({ path: "/permission/role/add" });
    },
    /**
     * [pageNavigateToPermissionRoleEdit description] 编辑
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    pageNavigateToPermissionRoleEdit: function (row) {
      this.$router.push({
        path: "/permission/role/add",
        query: { id: row.id },
      });
    },
    /**
     * [handleDelete description] 删除角色
     * @param  {[Object]} scope [description] 操作行的对象
     * @return {[type]}     [description]
     */
    handleDelete: function (scope) {
      this.deleteLoading = true;

      permissionRoleDelete({ id: scope.row.id })
        .then((res) => {
          this.deleteLoading = false;

          let { code, data, msg } = res;

          if (code == 0) {
            this.getList();
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.deleteLoading = false;
          this.$message.error("服务器异常");
        });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
@import "../../../common/styles/base/mixin-font";
@import "../../../common/styles/base/mixin-common";

.ml20 {
  margin-left: 20px;
}

.table-region {
  // margin-bottom: 50px;
}
</style>
